import React from 'react';


function ContactBitkala(props) {


return (
  <>
         <div class="block_infoinpage__header" >
           <div class="overlay">
          <div class="container">
            <div class="header_main">
              <h1 class="header_main--title" >همین حالا با ما تماس بگیرید!</h1>
              <p class="header_main--description">شما می توانید برای درخواست مشاوره رایگان و درخواست طراحی سایت ، وب اپلیکیشن ، موبایل اپلیکیشن با شماره 09124541231 در هر ساعت شبانه روز تماس بگیرید.</p>
            </div> 
            <div class="header_codeLineImage">
              <img src={require('./../img/EElan.png')} alt="کد"/>
              </div>
            </div>
        </div>
        </div>

  </>
) 
}

export default ContactBitkala;